module.exports = function( paper, x, y, text, font, fontSize, color ) {

    return paper.print( x, y, text, paper.getFont( font )).attr({
        color: color
    });

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/signature/createSignatureEl.js
 ** module id = 230
 ** module chunks = 0
 **/